<template>
  <div class="animated fadeIn offers--offers-list">
    <b-row>
      <b-col>
        <div class="pull-right tools add-offer">
          <b-button size="sm" @click="onCreatePO" variant="primary" :disabled="selectedRowItemId == 0 || loadingCreatePO" class="mr-1">
            <i v-if="loadingCreatePO" class="fa fa-spinner fa-pulse fa-fw mr-1" />
            Create PO
          </b-button>
          <b-button v-b-modal.vendor-offer-details size="sm" variant="primary" :disabled="selectedRowItemId == 0" class="mr-1">
            Email
          </b-button>
          <b-button v-if="checkClaim(CAN_ADD_OFFERS) && !hideNewOffer" @click="redirectToAdd" size="sm" variant="primary" class="mr-1">
            <i class="fa fa-plus" aria-hidden="true"></i>
            Req Offer
          </b-button>
          <b-button size="sm" variant="primary" @click="$bvModal.show('import-offer-modal')" class="mr-1">
            <i class="fa fa-plus mr-1" aria-hidden="true"></i>Import Offer
          </b-button>
          <b-button
            v-if="checkClaim(CAN_EDIT_OFFERS) && !hideActions"
            size="sm"
            variant="primary"
            :disabled="checkedRowItemIds.length === 0"
            @click="onAddToSources()">
            Post to Source
          </b-button>
        </div>
      </b-col>
    </b-row>
    <!-- TODO: Implement sorting in other areas such as sub-tabs -->
    <!--:styleCustom="(itemData.length > 0) ? 'height: 160px' : ''"-->
    <grid-component
        isResizable
        isReorderable
        :isSortable="!(partId || companyId)"
        :canEdit="checkClaim(CAN_EDIT_OFFERS)"
        :canDelete="checkClaim(CAN_DELETE_OFFERS)"
        :gridId="gridId"
        :itemData="itemData"
        :fields="offerGridIdFields"
        :sortBy="!(partId || companyId) ? filterInfo.sortBy : null"
        :sortOrder="!(partId || companyId) ? filterInfo.sortOrder : null"
        :sortMethod="!(partId || companyId) ? sortOffer : null"
        :onEdit="onEdit"
        :onDelete="onDelete"
        :handleRowClick="onRowClick"
        :navigationField="'partNumber'"
        :checkBoxValues="checkedRowItemIds"
        @checkedItem="checkedRowItemIds=$event"
        :styleCustom="'height: 160px'"
      />
    <quick-email :offer="selectedOffer" />
    <offer-form :modalId="modalOfferFormId" :partId="partIdOnForm" :lineId="lineIdOnForm" :offerId="offerIdOnForm" :companyId="companyIdOnForm" @onCloseModal="$emit('close-offer-form', $event)" @part-value="$emit('part-value', $event)" />
    <offer-import @refreshGrid="getOffersList" v-if="checkClaim(CAN_ADD_OFFERS) && !hideNewOffer" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions , mapMutations} from 'vuex';
import debounce from 'lodash/debounce';
import { date } from '@/shared/filters';
import GridSettings from '@/shared/components/GridSettings';
import { GRID_ID } from '@/shared/constants';
import { sortChange, prepareColumnsData } from '@/shared/helpers';
import offersFields from './fields';
import { addSourceOffersFields } from './fields';
import { OffersToSourcesDto } from './dto';
import GridComponent from '@/shared/components/GridComponent';
import QuickEmail from './components/QuickEmail';
import OfferForm from './components/AddOffer';
import OfferImport from '@/shared/components/Offers/components/ImportOffer';

export default {
  name: 'OffersGrid',
  components: {
    GridSettings,
    GridComponent,
    QuickEmail,
    OfferForm,
    OfferImport
  },
  props: {
    companyId: [String, Number],
    partId: [String, Number],
    fields: {
      default() {
        return offersFields;
      },
      type: Array,
    },
    gridId: {
      type: [Number, String],
      default: GRID_ID.OFFERS,
    },
    partNumber: {
      type: String,
      default: null,
    },
    filters: {
      type: Object,
      default: null,
    },
    crfqLineId: { // TODO this needs to be changed to rquirementLineId
      type: [Number, String],
      default: 0,
    },
    quoteLineId: {
      type: [Number, String],
      default: 0
    },
    salesOrderLineId: {
      type: [Number, String],
      default: 0
    },
    clearListOnPart: {
      type: Boolean,
      default: false,
    },
    hideNewOffer: {
      type: Boolean,
      default: false
    },
    hideActions: {
      type: Boolean,
      default: false
    },
    quoteId: [Number, String],
    salesOrderId: [Number, String],
    modalOfferFormId: {
      type: String,
      default: 'offer-form-modal'
    },
    isQuoteLine: [Boolean],
    isSalesOrderLine: [Boolean]
  },
  data() {
    return {
      prepareColumnsData,
      selectedRowItemId: 0,
      checkedRowItemIds: [],
      checkedRowItemsObjArr: [],
      date,
      sourceFields: addSourceOffersFields,
      selectedOffer: {},
      partIdOnForm: 0,
      offerIdOnForm: 0,
      lineIdOnForm: 0,
      companyIdOnForm: 0,
      loadingCreatePO: false
    };
  },
  computed: {
    ...mapState('offers', [
      'offersListFiltered',
      'filterInfo'
    ]),
    ...mapGetters('offers', ['offersList']),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      const offersListType = (this.partId || this.companyId) ? this.offersList : this.offersListFiltered;

      return offersListType.map((offer) => ({ ...offer, selected: offer.id === this.selectedRowItemId }));
    },
    checkAllRows: {
      get() {
        return this.itemData && this.itemData.length > 0 ? this.checkedRowItemIds.length === this.itemData.length : false;
      },
      set(value) {
        const checked = [];

        if (value) {
          this.itemData.forEach((item) => {
            checked.push(item.id);
          });
        }

        this.checkedRowItemIds = checked;
      },
    },
    offerGridIdFields() {
      return this.gridId == GRID_ID.OFFERS_SOURCES ? this.sourceFields : this.fields;
    }
  },
  methods: {
    ...mapActions('offers', [
      'getOffersForPartId',
      'getOffersFiltered',
      'deleteOffer',
      'sortInventory',
      'getEmptyVendorPartsList',
      'getOffersForVendorId',
      'setClickedAddOfferFromQuotesId',
      'addOffer',
      'sortOffer'
    ]),
    ...mapActions('account', ['saveGridSettings']),
    ...mapActions('requirements', ['addToSources']),
    ...mapActions('purchaseorders', ['createPOFromOffer']),
    ...mapActions('quoteLineSources', {addQuoteLineSource: 'addSources'}),
    ...mapActions('salesOrderLineSources', {addSalesOrderLineSource: 'addSources'}),
    /*...mapMutations('offers', ['setOffers']),*/
    ...mapMutations('offers', { setOfferItem: 'setItem' }),
    onDelete: async function(item) {
      const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to delete this offer?'});
      if (deleteConfirmed) {
        await this.deleteOffer(item.id);
        this.getOffersList();
      }
    },
    onEdit: function(item) {
      this.partIdOnForm = item.partId;
      this.lineIdOnForm = item.crfqLineId;
      this.companyIdOnForm = item.companyId;
      this.offerIdOnForm = item.id;

      console.log(this.offerIdOnForm, "Offer Id")
      this.$bvModal.show(this.modalOfferFormId);
    },
    async onCopy(item) {
      item.id = 0;
      await this.addOffer(item).then(() => {
        this.getOffersList();
        this.$snotify.success('Offer copied successfully', 'Offer')
      });
    },

    async onAddToSources() {
      this.$snotify.info('Posting Offer to Source', 'Sources');
      if (this.isQuoteLine) {
        await this.addQuoteLineSource(this.checkedRowItemsObjArr).then(() => {
          this.clearChecked();
          this.$snotify.success('Posted Offer to Source', 'Sources');
        });

         this.$emit('posted-source');
      } else if (this.isSalesOrderLine) {
        await this.addSalesOrderLineSource(this.checkedRowItemsObjArr).then((res) => {
          this.clearChecked();
          if(res!=undefined && res != null)
          {

          this.$snotify.success('Posted Offer to Source', 'Sources');
           this.$emit('posted-source');
          }
          else
           this.$snotify.error('Already Posted To Source','Sources');
        });

      } else {
        await this.addToSources(this.checkedRowItemsObjArr).then(() => {
          this.clearChecked();
          this.$snotify.success('Posted Offer to Source', 'Sources');
        });
         this.$emit('posted-source');
      }

     
    },
    redirectToAdd() {
      this.getEmptyVendorPartsList();
      this.partIdOnForm = this.partId || 0;
      this.lineIdOnForm = this.crfqLineId || 0;
      this.companyIdOnForm = 0;
      this.offerIdOnForm = 0;
      this.$bvModal.show(this.modalOfferFormId);
    },
    async getOffersList() {
      this.clearChecked();
      switch (this.gridId) {
        case GRID_ID.REQUIREMENT_OFFERS:
          await this.getOffersForPartId(this.partId);
          break;
        case GRID_ID.COMPANY_DETAILS_OFFERS:
          await this.getOffersForVendorId(this.companyId);
          break;
      }
    },
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      this.selectedOffer = row.dataItem;

      this.$emit('selectedSourceObj', row.dataItem);
    },
    clearChecked() {
      this.checkedRowItemsObjArr = this.checkedRowItemIds = [];
    },
    async onCreatePO() {
      try {
        this.loadingCreatePO = true;
        await this.createPOFromOffer(this.selectedRowItemId).then((res) => {
          this.loadingCreatePO = false;
          if (res && res.id > 0) {
            this.$snotify.success('Purchase Orders Created from Offer', 'Purchase Order');
            this.$router.push({
              name: 'purchaseorders.edit',
              params: {id: res.id},
            });
          }
        });
      }catch (e) {
        this.loadingCreatePO = false;
        /*console.log(e.message);*/
      }
    }
  },
  watch: {
    checkedRowItemIds() {
      const filteredObjArr = this.itemData.filter((obj) => this.checkedRowItemIds.includes(obj.id));

      this.checkedRowItemsObjArr = filteredObjArr.map(({ id, quantity, partId, cost, active }) => {
        const formattedQuantity = quantity || 0;
        const formattedCost = cost || 0;

        return {
          id: 0,
          requirementLineId: this.crfqLineId,
          quoteLineId: this.quoteLineId,
          salesOrderLineId: this.salesOrderLineId,
          vrfpLineId: id,
          quantity: formattedQuantity,
          partId,
          cost: formattedCost,
          active,
        };
      });
    },
    async partId() {
      if(!this.partId && this.clearListOnPart) {
        // this.setOffers([]);
        this.setOfferItem({ resource: 'offersList', payload: [] });
      }
      await this.getOffersList();
    },
    filters: {
      async handler() {
        this.$emit('searching', true);
        await this.getOffersFiltered(this.filters).then(() => this.$emit('searching', false));

      },
      deep: true,
    },
    companyId: function() {
      this.getOffersList();
    },
  },
  mounted() {
    if(!this.partId && this.clearListOnPart) {
      /*this.setOffers([]);*/
      this.setOfferItem({ resource: 'offersList', payload: [] });
    }
    if(this.partId || this.companyId) {
      this.clearChecked();
      this.getOffersList();
    } else if (this.modalOfferFormId != 'item-requirements-offer-form-modal') {
      /*this.setOffers([]);*/
      this.setOfferItem({ resource: 'offersList', payload: [] });
    }
    
    
    if (Object.keys(this.$route.query) && this.$route.hash == '#offers') {
      this.onEdit({
        ...this.$route.query,
        id: this.$route.query.offerId,
        companyId: this.$route.query.vendorId
      });
    }
  },
};
</script>

<style lang="scss">
.offers {
  &--offers-list {
    table td {
      cursor: pointer;
    }
  }
}

// .offers--offers-list {
//   margin-top: 20px;
// }

.add-offer {
  margin-top: 0.5em;
  margin-bottom: 1em;
}
</style>
